

export const customizeTranslations = (translations) => {
    translations['ra']['action']['edit'] = 'Modifier';

    return translations
};
